import { NowQuery } from "@/generated/graphql_billing";
import { ReferenceData } from "@/libs/test/referencedata";
import { graphql, HttpResponse } from "msw";

export const nowHandler = graphql.query<NowQuery>(
  "now",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        now: ReferenceData.now,
      },
    });
  }
);
